import CustomerServices from "@/services/CustomerServices";
import CustomerRequest from "@/model/requests/CustomerRequest";
import ProfessionalResponse from "@/model/responses/ProfessionalResponse";
import CustomerResponse from "@/model/responses/CustomerResponse";
import LoaderUtils from "@/utils/BaseUtils/LoaderUtils";
import ProfessionalServices from "@/services/ProfessionalServices";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
const customerService = new CustomerServices();

export const namespaced = true;

export const state = {
  customerInfo: {},
  updateSuccess: true,
  timezones: [],
  imageUrl: "",
  customerId: ""
};

export const getters = {
  getCustomerInfo: state => {
    return state.customerInfo;
  },
  getUpdateSuccess: state => {
    return state.updateSuccess;
  },
  getTimezones: state => {
    return state.timezones;
  },
  getImageUrl: state => {
    return state.imageUrl;
  }
};

export const mutations = {
  updateCustomerInfo: (state, payload) => {
    state.customerInfo = payload;
  },
  updateSuccessful: (state, payload) => {
    state.updateSuccess = payload;
  },
  updateTimezones: (state, payload) => {
    state.timezones = payload;
  },
  updateImageUrl: (state, payload) => {
    state.imageUrl = payload;
  },
  updateCustomerId: (state, payload) => {
    state.customerId = payload;
  }
};

export const actions = {
  createCustomer({ commit }, payload = CustomerRequest.create) {},
  readByCustomerId({ commit }, payload = CustomerRequest.readBy) {
    let successAction = responseData => {
      commit("updateCustomerInfo", responseData.data);
      commit("updateImageUrl", responseData.data.customerDisplayPicture);
    };
    return customerService.readByCustomer(
      payload,
      successAction,
      LoaderUtils.types.NONE
    );
  },
  updateCustomer({ commit }, payload = CustomerRequest.update) {
    let successAction = () => {
      let customerId = StoreUtils.rootGetters("auth/getUserInfo").customerId;
      StoreUtils.dispatch("customer/readByCustomerId", { customerId });
    };

    return customerService.updateCustomer(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  uploadImage({ commit }, payload = CustomerRequest.uploadImage) {
    let successAction = responseData => {
      commit("updateImageUrl", responseData.data);
      CustomerRequest.update.customerDisplayPicture = responseData.data;

      // let customerDisplayPicture = StoreUtils.rootGetters(
      //   "customer/getImageUrl"
      // );
      // let customerId = StoreUtils.rootGetters("auth/getUserInfo").customerId;
      // return StoreUtils.dispatch("customer/updateCustomer", {
      //   customerDisplayPicture,
      //   customerId
      // });
    };
    return customerService.uploadImage(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readTimezones({ commit }) {
    let successAction = responseData => {
      commit("updateTimezones", responseData.data);
    };

    return customerService.readTimezones(
      {},
      successAction,
      LoaderUtils.types.NONE
    );
  }
};
